/**
 *
 * @param elm
 */
export function setInputInvalid(elm){

}

/**
 *
 * @param elm
 */
export function setInputActive(elm,id){
	elm.find(`label[for="${id}"]`)
		.addClass('active');

}
/**
 *
 * @param elm
 */
export function setLabelActiveByInputId(id){
	$(`label[for="${id}"]`).addClass('active').removeClass('error').siblings('i.prefix').removeClass('error');
}
/**
 *
 * @param elm
 */
export function setLabelErrorByInputId(id){
	$(`label[for="${id}"]`).addClass('error active').siblings('i.prefix').addClass('error active');
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/forms.js